import styled from "styled-components";
import { style } from "../style";

export const FieldSetLegend = styled.legend`
  font-size: ${style.vars.fontSize.base};
  font-weight: ${style.vars.fontWeight.bold};
  text-transform: unset;
  letter-spacing: unset;
  padding: 0;
  margin: 0 0 ${style.vars.whitespace.xsmall} 0;
`;

export const FieldSet = styled.fieldset`
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
  margin-bottom: ${style.vars.whitespace.medium};

  *:last-child {
    margin-bottom: 0;
  }
`;
